import { Component, OnInit } from '@angular/core';
import { AuthService } from '@app/shared';
import { NguAlertService } from '@app/shared';
import {Router} from '@angular/router';

@Component({
  selector: 'app-no-access',
  templateUrl: './no-access.component.html',
  styleUrls: ['./no-access.component.scss']
})
export class NoAccessComponent implements OnInit {

  constructor(private auth: AuthService, private alert: NguAlertService, private router: Router,) { }

  ngOnInit() {
    this.auth.pageTitle = undefined;
    console.log("test access denied");
    this.alert.open({
      heading: 'Access Denied',
      msg: `You don't have permission to access this page. Please contact adminstrator `,
      type: 'danger'
    });
    setTimeout(() => {
      this.alert.open({
        heading: 'Redirecting to Home page',
        msg: `Please click "Home" if you are not redirected to Home page in few seconds`,
        type: 'info'
      });
      this.router.navigate([this.auth.defaultUrl]);
    },3000);
  }

}
